import React from "react";
import LoginHeader from "../Login/LoginHeader";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/authSlice";

const SupplierInstructions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen bg-white">
      <LoginHeader isAuthenticated={isAuthenticated} registrationPage={true} />
      <div className="flex-1 flex justify-center items-center pt-[80px] md:pt-[100px]">
        <section className="flex flex-col min-h-screen justify-start items-center w-full max-w-[870px] p-6">
          <header className="mb-14">
            <h3 className="text-xl font-medium text-[#7E7E7E] text-center">
              Instructions
            </h3>
            <h1 className="text-2xl font-semibold text-[#1D2639] text-center">
              Supplier Registration: What You'll Need to Complete Your Profile
            </h1>
            <p className="text-base font-medium text-[#7E7E7E] text-center mt-2">
              To help us better match your business with sourcing opportunities
              and ensure compliance with buyer requirements, please have the
              following information ready before completing your company
              profile:
            </p>
          </header>

          <div className="text-left space-y-4">
            <div>
              <h3 className="font-semibold text-base text-[#1D2739]">
                Company Information:
              </h3>
              <ul className="list-disc list-inside text-base text-[#1D2739] mt-2 space-y-1 pl-4">
                <li>Business name and description</li>
                <li>Business address and primary contact information</li>
                <li>Tax Identification Number (TIN)</li>
                <li>
                  NAICS (North American Industry Classification System) code
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-base text-[#1D2739]">
                Diversity Classification (if applicable):
              </h3>
              <ul className="text-[#1D2739] list-disc list-inside text-base mt-2 space-y-1 pl-4">
                <li>
                  Any diversity classifications your business holds (e.g.,
                  Women-Owned, Minority-Owned, Veteran-Owned, etc.)
                </li>
                <li>
                  Relevant certification documents to verify your diversity
                  status
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 flex flex-col items-center space-y-4">
            <button
              className="flex justify-center cursor-pointer items-center self-center w-full sm:w-[572px] h-14 p-5 mt-14
        rounded-[13px] text-center text-base font-medium bg-[#eaf524] text-black"
              onClick={() =>
                navigate("/supplier-profile-registration/personal-details")
              }
            >
              I am ready
            </button>
            <button
              className="flex justify-center cursor-pointer items-center self-center w-full sm:w-[572px] h-14 p-5 mt-14
        rounded-[13px] text-center text-base font-medium bg-white text-black border"
              onClick={handleLogout}
            >
              Log back in later to finish
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SupplierInstructions;
